import { EPFDeclarationForm } from './EPFDeclarationForm';
import { ESICDeclarationForm } from './ESICDeclarationForm';
import HRDeclarationForm from './HRDeclarationForm';
import HrEmploymentCard from './HrEmploymentCard';
import HRNominationForm from './HRNominationForm';

const forms = {
  declarationFormEPFO: prop => <EPFDeclarationForm {...prop} />,
  hrDeclarationForm: prop => <HRDeclarationForm {...prop} />,
  nominationForm: prop => <HRNominationForm {...prop} />,
  employmentCard: prop => <HrEmploymentCard {...prop} />,
  declarationFormESIC: prop => <ESICDeclarationForm {...prop} />
};

export default forms;
